import React, { FC } from 'react';
import { Icon, IconProps } from '@agria/theme/src/components/icon/Icon';

export const Expand: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      d="M16.09 19.5001L11 14.4151C9.99999 13.5001 11.5 12.0002 12.415 13.0001L16.09 16.6751L19.765 13.0001C20.75 12 22 13.75 21.18 14.4151L16.09 19.5001Z"
      fill="currentColor"
    />
  </Icon>
);
